import { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { quoteHref } from "../../data/homeContent";
import { trackEvent } from "../../lib/api";

const HEADER_COMPACT = 65;

// Scrollt zo dat de sectietitel volledig onder de hoofdheader én de subnavigatie valt.
const scrollToSection = (id, nav, smooth = true) => {
  const el = document.getElementById(id);
  if (!el) return;
  const heading = el.querySelector("h2") || el;
  const offset = HEADER_COMPACT + (nav?.offsetHeight || 56) + 24;
  const top = heading.getBoundingClientRect().top + window.scrollY - offset;
  window.scrollTo({ top: Math.max(0, top), behavior: smooth ? "smooth" : "auto" });
};

export const ProductSubnav = ({ items, onderwerp, params }) => {
  const ref = useRef(null);
  useEffect(() => {
    const id = window.location.hash.slice(1);
    if (id && items.some(([i]) => i === id)) setTimeout(() => scrollToSection(id, ref.current, false), 300);
  }, [items]);
  const go = (e, id) => {
    e.preventDefault();
    window.history.replaceState(null, "", `#${id}`);
    scrollToSection(id, ref.current);
    setTimeout(() => scrollToSection(id, ref.current), 700);
  };
  return (
    <nav ref={ref} aria-label="Op deze pagina" className="sticky top-[60px] z-30 border-y border-slate-200 bg-white/95 backdrop-blur-md lg:top-16" data-testid="product-subnav">
      <div className="container-tight flex items-center gap-4">
        <ul className="-mx-1 flex flex-1 gap-1 overflow-x-auto py-2 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
          {items.map(([id, label]) => (
            <li key={id}>
              <a href={`#${id}`} onClick={(e) => go(e, id)} className="block whitespace-nowrap rounded-lg px-3 py-2 text-[14px] font-medium text-slate-600 transition-colors hover:bg-slate-50 hover:text-maas"
                data-testid={`subnav-${id}`}>{label}</a>
            </li>
          ))}
        </ul>
        <Link to={quoteHref(onderwerp, params)} onClick={() => trackEvent("cta_quote_click", { location: "product-subnav" })}
          className="hidden shrink-0 items-center gap-1.5 rounded-lg bg-maas px-4 py-2 text-[14px] font-semibold text-white hover:bg-maas-hover md:inline-flex"
          data-testid="subnav-quote-cta">
          Prijsindicatie <ArrowRight className="h-4 w-4" aria-hidden="true" />
        </Link>
      </div>
    </nav>
  );
};
